//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IMIPClient {
    getToken(): Observable<TokenModel>;
    getPassportPersonData(gcpInputData: GCPRequestApi): Observable<PassportPersonApi>;
    getPersonDocDataWithPhoto(requestCadastr: RequestCadastr): Observable<GetDataByPinppResponseData>;
    getPersonDiplomData(requestDiploma: RequestDiploma): Observable<PersonDiplomApi[]>;
    getEmployeeHistoryInfo(laborApiRequest: LaborApiRequest): Observable<EmployeeWorkDataModel>;
    getEmployeeCurrentInfo(laborApiRequest: LaborApiRequest): Observable<EmployeeCurrentWorkDataModel>;
    getPedCategoriesByPassportAndPINFL(request: PedCategoryRequestAPI): Observable<PedCategoryDto[]>;
    getPersonPhotoByPassportAndPINFL(request: GcpWithPhotoRequestDto): Observable<string>;
    getPersonDataFromGcp(passport: string | undefined, birthDate: Date | undefined): Observable<GcpWithPhotoResponseDto>;
    getPersonDataFromGcpByPinfl(pinfl: string | undefined): Observable<GcpWithPhotoResponseDto>;
}

@Injectable({
    providedIn: 'root'
})
export class MIPClient implements IMIPClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getToken(): Observable<TokenModel> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenModel>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<TokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPassportPersonData(gcpInputData: GCPRequestApi): Observable<PassportPersonApi> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetPassportPersonData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gcpInputData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPassportPersonData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPassportPersonData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PassportPersonApi>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PassportPersonApi>;
        }));
    }

    protected processGetPassportPersonData(response: HttpResponseBase): Observable<PassportPersonApi> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassportPersonApi.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonDocDataWithPhoto(requestCadastr: RequestCadastr): Observable<GetDataByPinppResponseData> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetPersonDocDataWithPhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestCadastr);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonDocDataWithPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonDocDataWithPhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDataByPinppResponseData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDataByPinppResponseData>;
        }));
    }

    protected processGetPersonDocDataWithPhoto(response: HttpResponseBase): Observable<GetDataByPinppResponseData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDataByPinppResponseData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonDiplomData(requestDiploma: RequestDiploma): Observable<PersonDiplomApi[]> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetPersonDiplomData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDiploma);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonDiplomData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonDiplomData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDiplomApi[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDiplomApi[]>;
        }));
    }

    protected processGetPersonDiplomData(response: HttpResponseBase): Observable<PersonDiplomApi[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonDiplomApi.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeHistoryInfo(laborApiRequest: LaborApiRequest): Observable<EmployeeWorkDataModel> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetEmployeeHistoryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(laborApiRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeHistoryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeHistoryInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeWorkDataModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeWorkDataModel>;
        }));
    }

    protected processGetEmployeeHistoryInfo(response: HttpResponseBase): Observable<EmployeeWorkDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeWorkDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeCurrentInfo(laborApiRequest: LaborApiRequest): Observable<EmployeeCurrentWorkDataModel> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetEmployeeCurrentInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(laborApiRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeCurrentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeCurrentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCurrentWorkDataModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCurrentWorkDataModel>;
        }));
    }

    protected processGetEmployeeCurrentInfo(response: HttpResponseBase): Observable<EmployeeCurrentWorkDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeCurrentWorkDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPedCategoriesByPassportAndPINFL(request: PedCategoryRequestAPI): Observable<PedCategoryDto[]> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetPedCategoriesByPassportAndPINFL";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPedCategoriesByPassportAndPINFL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPedCategoriesByPassportAndPINFL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PedCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PedCategoryDto[]>;
        }));
    }

    protected processGetPedCategoriesByPassportAndPINFL(response: HttpResponseBase): Observable<PedCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PedCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonPhotoByPassportAndPINFL(request: GcpWithPhotoRequestDto): Observable<string> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetPersonPhotoByPassportAndPINFL";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonPhotoByPassportAndPINFL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonPhotoByPassportAndPINFL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPersonPhotoByPassportAndPINFL(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonDataFromGcp(passport: string | undefined, birthDate: Date | undefined): Observable<GcpWithPhotoResponseDto> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetPersonDataFromGcp?";
        if (passport === null)
            throw new Error("The parameter 'passport' cannot be null.");
        else if (passport !== undefined)
            url_ += "passport=" + encodeURIComponent("" + passport) + "&";
        if (birthDate === null)
            throw new Error("The parameter 'birthDate' cannot be null.");
        else if (birthDate !== undefined)
            url_ += "birthDate=" + encodeURIComponent(birthDate ? "" + birthDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonDataFromGcp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonDataFromGcp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GcpWithPhotoResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GcpWithPhotoResponseDto>;
        }));
    }

    protected processGetPersonDataFromGcp(response: HttpResponseBase): Observable<GcpWithPhotoResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GcpWithPhotoResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonDataFromGcpByPinfl(pinfl: string | undefined): Observable<GcpWithPhotoResponseDto> {
        let url_ = this.baseUrl + "/api/mip2/MIP/GetPersonDataFromGcpByPinfl?";
        if (pinfl === null)
            throw new Error("The parameter 'pinfl' cannot be null.");
        else if (pinfl !== undefined)
            url_ += "pinfl=" + encodeURIComponent("" + pinfl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonDataFromGcpByPinfl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonDataFromGcpByPinfl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GcpWithPhotoResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GcpWithPhotoResponseDto>;
        }));
    }

    protected processGetPersonDataFromGcpByPinfl(response: HttpResponseBase): Observable<GcpWithPhotoResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GcpWithPhotoResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class TokenModel implements ITokenModel {
    access_token!: string;
    refresh_token!: string;
    scope!: string;
    token_type!: string;
    expires_in!: number;

    constructor(data?: ITokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.refresh_token = _data["refresh_token"];
            this.scope = _data["scope"];
            this.token_type = _data["token_type"];
            this.expires_in = _data["expires_in"];
        }
    }

    static fromJS(data: any): TokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["refresh_token"] = this.refresh_token;
        data["scope"] = this.scope;
        data["token_type"] = this.token_type;
        data["expires_in"] = this.expires_in;
        return data;
    }
}

export interface ITokenModel {
    access_token: string;
    refresh_token: string;
    scope: string;
    token_type: string;
    expires_in: number;
}

export class PassportPersonApi implements IPassportPersonApi {
    pIssuedDate!: string;
    pPlaceBirth!: string;
    pPinpp!: string;
    pPatronym!: string;
    pSurname!: string;
    pName!: string;
    pAnswereId!: string;
    pIssuedBy!: string;
    pSex?: string | undefined;
    pSurnameEng!: string;
    pNameEng!: string;
    pPsp!: string;
    pNationality!: string;
    pNationalityId?: string | undefined;
    pCitizenship!: string;
    pCitizenshipId?: string | undefined;
    pDateBirth!: string;
    pValidDate!: string;
    pAnswereMessage!: string;
    spRegionId?: string | undefined;
    spDistrictId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    countryName!: string;
    passportSeria!: string;
    passportNumber!: string;
    imageId?: number | undefined;

    constructor(data?: IPassportPersonApi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pIssuedDate = _data["pIssuedDate"];
            this.pPlaceBirth = _data["pPlaceBirth"];
            this.pPinpp = _data["pPinpp"];
            this.pPatronym = _data["pPatronym"];
            this.pSurname = _data["pSurname"];
            this.pName = _data["pName"];
            this.pAnswereId = _data["pAnswereId"];
            this.pIssuedBy = _data["pIssuedBy"];
            this.pSex = _data["pSex"];
            this.pSurnameEng = _data["pSurnameEng"];
            this.pNameEng = _data["pNameEng"];
            this.pPsp = _data["pPsp"];
            this.pNationality = _data["pNationality"];
            this.pNationalityId = _data["pNationalityId"];
            this.pCitizenship = _data["pCitizenship"];
            this.pCitizenshipId = _data["pCitizenshipId"];
            this.pDateBirth = _data["pDateBirth"];
            this.pValidDate = _data["pValidDate"];
            this.pAnswereMessage = _data["pAnswereMessage"];
            this.spRegionId = _data["spRegionId"];
            this.spDistrictId = _data["spDistrictId"];
            this.address = _data["address"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.passportSeria = _data["passportSeria"];
            this.passportNumber = _data["passportNumber"];
            this.imageId = _data["imageId"];
        }
    }

    static fromJS(data: any): PassportPersonApi {
        data = typeof data === 'object' ? data : {};
        let result = new PassportPersonApi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pIssuedDate"] = this.pIssuedDate;
        data["pPlaceBirth"] = this.pPlaceBirth;
        data["pPinpp"] = this.pPinpp;
        data["pPatronym"] = this.pPatronym;
        data["pSurname"] = this.pSurname;
        data["pName"] = this.pName;
        data["pAnswereId"] = this.pAnswereId;
        data["pIssuedBy"] = this.pIssuedBy;
        data["pSex"] = this.pSex;
        data["pSurnameEng"] = this.pSurnameEng;
        data["pNameEng"] = this.pNameEng;
        data["pPsp"] = this.pPsp;
        data["pNationality"] = this.pNationality;
        data["pNationalityId"] = this.pNationalityId;
        data["pCitizenship"] = this.pCitizenship;
        data["pCitizenshipId"] = this.pCitizenshipId;
        data["pDateBirth"] = this.pDateBirth;
        data["pValidDate"] = this.pValidDate;
        data["pAnswereMessage"] = this.pAnswereMessage;
        data["spRegionId"] = this.spRegionId;
        data["spDistrictId"] = this.spDistrictId;
        data["address"] = this.address;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["passportSeria"] = this.passportSeria;
        data["passportNumber"] = this.passportNumber;
        data["imageId"] = this.imageId;
        return data;
    }
}

export interface IPassportPersonApi {
    pIssuedDate: string;
    pPlaceBirth: string;
    pPinpp: string;
    pPatronym: string;
    pSurname: string;
    pName: string;
    pAnswereId: string;
    pIssuedBy: string;
    pSex?: string | undefined;
    pSurnameEng: string;
    pNameEng: string;
    pPsp: string;
    pNationality: string;
    pNationalityId?: string | undefined;
    pCitizenship: string;
    pCitizenshipId?: string | undefined;
    pDateBirth: string;
    pValidDate: string;
    pAnswereMessage: string;
    spRegionId?: string | undefined;
    spDistrictId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    countryName: string;
    passportSeria: string;
    passportNumber: string;
    imageId?: number | undefined;
}

export class GCPRequestApi implements IGCPRequestApi {
    birthDate!: string;
    pspSerial!: string;
    pspNumber!: string;

    constructor(data?: IGCPRequestApi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"];
            this.pspSerial = _data["pspSerial"];
            this.pspNumber = _data["pspNumber"];
        }
    }

    static fromJS(data: any): GCPRequestApi {
        data = typeof data === 'object' ? data : {};
        let result = new GCPRequestApi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate;
        data["pspSerial"] = this.pspSerial;
        data["pspNumber"] = this.pspNumber;
        return data;
    }
}

export interface IGCPRequestApi {
    birthDate: string;
    pspSerial: string;
    pspNumber: string;
}

export class GetDataByPinppResponseData implements IGetDataByPinppResponseData {
    result!: number;
    data!: PersonInfoWithPhotoModel;

    constructor(data?: IGetDataByPinppResponseData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new PersonInfoWithPhotoModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.data = _data["data"] ? PersonInfoWithPhotoModel.fromJS(_data["data"]) : new PersonInfoWithPhotoModel();
        }
    }

    static fromJS(data: any): GetDataByPinppResponseData {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataByPinppResponseData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDataByPinppResponseData {
    result: number;
    data: PersonInfoWithPhotoModel;
}

export class PersonInfoWithPhotoModel implements IPersonInfoWithPhotoModel {
    pinpp!: number;
    doc_seria!: string;
    doc_number!: string;
    surnamelatin!: string;
    namelatin!: string;
    patronymlatin!: string;
    engsurname!: string;
    engname!: string;
    birthdate!: string;
    birthplace!: string;
    birthplaceid?: number | undefined;
    birthcountry!: string;
    birthcountryid?: number | undefined;
    livestatus?: number | undefined;
    nationality!: string;
    nationalityid?: number | undefined;
    citizenship!: string;
    citizenshipid?: number | undefined;
    sex?: number | undefined;
    docgiveplace!: string;
    docgiveplaceid!: string;
    docdatebegin?: Date | undefined;
    docdateend?: Date | undefined;
    photo!: string;

    constructor(data?: IPersonInfoWithPhotoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pinpp = _data["pinpp"];
            this.doc_seria = _data["doc_seria"];
            this.doc_number = _data["doc_number"];
            this.surnamelatin = _data["surnamelatin"];
            this.namelatin = _data["namelatin"];
            this.patronymlatin = _data["patronymlatin"];
            this.engsurname = _data["engsurname"];
            this.engname = _data["engname"];
            this.birthdate = _data["birthdate"];
            this.birthplace = _data["birthplace"];
            this.birthplaceid = _data["birthplaceid"];
            this.birthcountry = _data["birthcountry"];
            this.birthcountryid = _data["birthcountryid"];
            this.livestatus = _data["livestatus"];
            this.nationality = _data["nationality"];
            this.nationalityid = _data["nationalityid"];
            this.citizenship = _data["citizenship"];
            this.citizenshipid = _data["citizenshipid"];
            this.sex = _data["sex"];
            this.docgiveplace = _data["docgiveplace"];
            this.docgiveplaceid = _data["docgiveplaceid"];
            this.docdatebegin = _data["docdatebegin"] ? new Date(_data["docdatebegin"].toString()) : <any>undefined;
            this.docdateend = _data["docdateend"] ? new Date(_data["docdateend"].toString()) : <any>undefined;
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): PersonInfoWithPhotoModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonInfoWithPhotoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinpp"] = this.pinpp;
        data["doc_seria"] = this.doc_seria;
        data["doc_number"] = this.doc_number;
        data["surnamelatin"] = this.surnamelatin;
        data["namelatin"] = this.namelatin;
        data["patronymlatin"] = this.patronymlatin;
        data["engsurname"] = this.engsurname;
        data["engname"] = this.engname;
        data["birthdate"] = this.birthdate;
        data["birthplace"] = this.birthplace;
        data["birthplaceid"] = this.birthplaceid;
        data["birthcountry"] = this.birthcountry;
        data["birthcountryid"] = this.birthcountryid;
        data["livestatus"] = this.livestatus;
        data["nationality"] = this.nationality;
        data["nationalityid"] = this.nationalityid;
        data["citizenship"] = this.citizenship;
        data["citizenshipid"] = this.citizenshipid;
        data["sex"] = this.sex;
        data["docgiveplace"] = this.docgiveplace;
        data["docgiveplaceid"] = this.docgiveplaceid;
        data["docdatebegin"] = this.docdatebegin ? this.docdatebegin.toISOString() : <any>undefined;
        data["docdateend"] = this.docdateend ? this.docdateend.toISOString() : <any>undefined;
        data["photo"] = this.photo;
        return data;
    }
}

export interface IPersonInfoWithPhotoModel {
    pinpp: number;
    doc_seria: string;
    doc_number: string;
    surnamelatin: string;
    namelatin: string;
    patronymlatin: string;
    engsurname: string;
    engname: string;
    birthdate: string;
    birthplace: string;
    birthplaceid?: number | undefined;
    birthcountry: string;
    birthcountryid?: number | undefined;
    livestatus?: number | undefined;
    nationality: string;
    nationalityid?: number | undefined;
    citizenship: string;
    citizenshipid?: number | undefined;
    sex?: number | undefined;
    docgiveplace: string;
    docgiveplaceid: string;
    docdatebegin?: Date | undefined;
    docdateend?: Date | undefined;
    photo: string;
}

export class RequestCadastr implements IRequestCadastr {
    pinfl!: string;
    docGivenDate!: string;

    constructor(data?: IRequestCadastr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pinfl = _data["pinfl"];
            this.docGivenDate = _data["docGivenDate"];
        }
    }

    static fromJS(data: any): RequestCadastr {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCadastr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinfl"] = this.pinfl;
        data["docGivenDate"] = this.docGivenDate;
        return data;
    }
}

export interface IRequestCadastr {
    pinfl: string;
    docGivenDate: string;
}

export class PersonDiplomApi implements IPersonDiplomApi {
    pinfl?: string | undefined;
    edu_type_id?: number | undefined;
    edu_type_name?: string | undefined;
    institution_type_id?: number | undefined;
    institution_type_name?: string | undefined;
    institution_id?: number | undefined;
    institution_name?: string | undefined;
    institution_old_name_id?: number | undefined;
    institution_old_name?: string | undefined;
    degree_id?: number | undefined;
    degree_name?: string | undefined;
    edu_form_id?: number | undefined;
    edu_form_name?: string | undefined;
    speciality_id?: number | undefined;
    speciality_old_id?: number | undefined;
    speciality_name?: string | undefined;
    speciality_code?: string | undefined;
    edu_duration_id?: number | undefined;
    edu_duration_name?: string | undefined;
    edu_starting_date?: string | undefined;
    edu_finishing_date?: string | undefined;
    diploma_given_date?: string | undefined;
    diploma_serial_id?: number | undefined;
    diploma_serial?: string | undefined;
    diploma_number?: string | undefined;
    diploma_type_id?: number | undefined;
    diploma_type_name?: string | undefined;
    status_id?: number | undefined;
    status_name?: string | undefined;

    constructor(data?: IPersonDiplomApi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pinfl = _data["pinfl"];
            this.edu_type_id = _data["edu_type_id"];
            this.edu_type_name = _data["edu_type_name"];
            this.institution_type_id = _data["institution_type_id"];
            this.institution_type_name = _data["institution_type_name"];
            this.institution_id = _data["institution_id"];
            this.institution_name = _data["institution_name"];
            this.institution_old_name_id = _data["institution_old_name_id"];
            this.institution_old_name = _data["institution_old_name"];
            this.degree_id = _data["degree_id"];
            this.degree_name = _data["degree_name"];
            this.edu_form_id = _data["edu_form_id"];
            this.edu_form_name = _data["edu_form_name"];
            this.speciality_id = _data["speciality_id"];
            this.speciality_old_id = _data["speciality_old_id"];
            this.speciality_name = _data["speciality_name"];
            this.speciality_code = _data["speciality_code"];
            this.edu_duration_id = _data["edu_duration_id"];
            this.edu_duration_name = _data["edu_duration_name"];
            this.edu_starting_date = _data["edu_starting_date"];
            this.edu_finishing_date = _data["edu_finishing_date"];
            this.diploma_given_date = _data["diploma_given_date"];
            this.diploma_serial_id = _data["diploma_serial_id"];
            this.diploma_serial = _data["diploma_serial"];
            this.diploma_number = _data["diploma_number"];
            this.diploma_type_id = _data["diploma_type_id"];
            this.diploma_type_name = _data["diploma_type_name"];
            this.status_id = _data["status_id"];
            this.status_name = _data["status_name"];
        }
    }

    static fromJS(data: any): PersonDiplomApi {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDiplomApi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinfl"] = this.pinfl;
        data["edu_type_id"] = this.edu_type_id;
        data["edu_type_name"] = this.edu_type_name;
        data["institution_type_id"] = this.institution_type_id;
        data["institution_type_name"] = this.institution_type_name;
        data["institution_id"] = this.institution_id;
        data["institution_name"] = this.institution_name;
        data["institution_old_name_id"] = this.institution_old_name_id;
        data["institution_old_name"] = this.institution_old_name;
        data["degree_id"] = this.degree_id;
        data["degree_name"] = this.degree_name;
        data["edu_form_id"] = this.edu_form_id;
        data["edu_form_name"] = this.edu_form_name;
        data["speciality_id"] = this.speciality_id;
        data["speciality_old_id"] = this.speciality_old_id;
        data["speciality_name"] = this.speciality_name;
        data["speciality_code"] = this.speciality_code;
        data["edu_duration_id"] = this.edu_duration_id;
        data["edu_duration_name"] = this.edu_duration_name;
        data["edu_starting_date"] = this.edu_starting_date;
        data["edu_finishing_date"] = this.edu_finishing_date;
        data["diploma_given_date"] = this.diploma_given_date;
        data["diploma_serial_id"] = this.diploma_serial_id;
        data["diploma_serial"] = this.diploma_serial;
        data["diploma_number"] = this.diploma_number;
        data["diploma_type_id"] = this.diploma_type_id;
        data["diploma_type_name"] = this.diploma_type_name;
        data["status_id"] = this.status_id;
        data["status_name"] = this.status_name;
        return data;
    }
}

export interface IPersonDiplomApi {
    pinfl?: string | undefined;
    edu_type_id?: number | undefined;
    edu_type_name?: string | undefined;
    institution_type_id?: number | undefined;
    institution_type_name?: string | undefined;
    institution_id?: number | undefined;
    institution_name?: string | undefined;
    institution_old_name_id?: number | undefined;
    institution_old_name?: string | undefined;
    degree_id?: number | undefined;
    degree_name?: string | undefined;
    edu_form_id?: number | undefined;
    edu_form_name?: string | undefined;
    speciality_id?: number | undefined;
    speciality_old_id?: number | undefined;
    speciality_name?: string | undefined;
    speciality_code?: string | undefined;
    edu_duration_id?: number | undefined;
    edu_duration_name?: string | undefined;
    edu_starting_date?: string | undefined;
    edu_finishing_date?: string | undefined;
    diploma_given_date?: string | undefined;
    diploma_serial_id?: number | undefined;
    diploma_serial?: string | undefined;
    diploma_number?: string | undefined;
    diploma_type_id?: number | undefined;
    diploma_type_name?: string | undefined;
    status_id?: number | undefined;
    status_name?: string | undefined;
}

export class RequestDiploma implements IRequestDiploma {
    pinfl!: string;

    constructor(data?: IRequestDiploma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pinfl = _data["pinfl"];
        }
    }

    static fromJS(data: any): RequestDiploma {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDiploma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinfl"] = this.pinfl;
        return data;
    }
}

export interface IRequestDiploma {
    pinfl: string;
}

export class EmployeeWorkDataModel implements IEmployeeWorkDataModel {
    error!: string;
    id!: number;
    jsonrpc!: string;
    result!: EmployeeResult;

    constructor(data?: IEmployeeWorkDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.result = new EmployeeResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.id = _data["id"];
            this.jsonrpc = _data["jsonrpc"];
            this.result = _data["result"] ? EmployeeResult.fromJS(_data["result"]) : new EmployeeResult();
        }
    }

    static fromJS(data: any): EmployeeWorkDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeWorkDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["id"] = this.id;
        data["jsonrpc"] = this.jsonrpc;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeWorkDataModel {
    error: string;
    id: number;
    jsonrpc: string;
    result: EmployeeResult;
}

export class EmployeeResult implements IEmployeeResult {
    code!: number;
    message!: string;
    success!: boolean;
    data!: EmployeeData;

    constructor(data?: IEmployeeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new EmployeeData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.success = _data["success"];
            this.data = _data["data"] ? EmployeeData.fromJS(_data["data"]) : new EmployeeData();
        }
    }

    static fromJS(data: any): EmployeeResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["success"] = this.success;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeResult {
    code: number;
    message: string;
    success: boolean;
    data: EmployeeData;
}

export class EmployeeData implements IEmployeeData {
    experiences!: EmployeeExperiences[];
    profile!: Profile;

    constructor(data?: IEmployeeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.experiences = [];
            this.profile = new Profile();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["experiences"])) {
                this.experiences = [] as any;
                for (let item of _data["experiences"])
                    this.experiences!.push(EmployeeExperiences.fromJS(item));
            }
            this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : new Profile();
        }
    }

    static fromJS(data: any): EmployeeData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.experiences)) {
            data["experiences"] = [];
            for (let item of this.experiences)
                data["experiences"].push(item.toJSON());
        }
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeData {
    experiences: EmployeeExperiences[];
    profile: Profile;
}

export class EmployeeExperiences implements IEmployeeExperiences {
    company_inn!: string;
    company_name!: string;
    structure_name!: string;
    position_name!: string;
    start_date!: string;
    end_date!: string;
    kodp!: string;
    kodp_type!: string;
    soato_code!: string;
    transaction_id!: number;
    workplace_address!: string;
    order_date!: string;
    order_number!: string;
    contract_date!: string;
    contract_number!: string;

    constructor(data?: IEmployeeExperiences) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_inn = _data["company_inn"];
            this.company_name = _data["company_name"];
            this.structure_name = _data["structure_name"];
            this.position_name = _data["position_name"];
            this.start_date = _data["start_date"];
            this.end_date = _data["end_date"];
            this.kodp = _data["kodp"];
            this.kodp_type = _data["kodp_type"];
            this.soato_code = _data["soato_code"];
            this.transaction_id = _data["transaction_id"];
            this.workplace_address = _data["workplace_address"];
            this.order_date = _data["order_date"];
            this.order_number = _data["order_number"];
            this.contract_date = _data["contract_date"];
            this.contract_number = _data["contract_number"];
        }
    }

    static fromJS(data: any): EmployeeExperiences {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExperiences();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_inn"] = this.company_inn;
        data["company_name"] = this.company_name;
        data["structure_name"] = this.structure_name;
        data["position_name"] = this.position_name;
        data["start_date"] = this.start_date;
        data["end_date"] = this.end_date;
        data["kodp"] = this.kodp;
        data["kodp_type"] = this.kodp_type;
        data["soato_code"] = this.soato_code;
        data["transaction_id"] = this.transaction_id;
        data["workplace_address"] = this.workplace_address;
        data["order_date"] = this.order_date;
        data["order_number"] = this.order_number;
        data["contract_date"] = this.contract_date;
        data["contract_number"] = this.contract_number;
        return data;
    }
}

export interface IEmployeeExperiences {
    company_inn: string;
    company_name: string;
    structure_name: string;
    position_name: string;
    start_date: string;
    end_date: string;
    kodp: string;
    kodp_type: string;
    soato_code: string;
    transaction_id: number;
    workplace_address: string;
    order_date: string;
    order_number: string;
    contract_date: string;
    contract_number: string;
}

export class Profile implements IProfile {
    birth_date!: string;
    gender!: number;
    person_name!: string;
    person_patronymic!: string;
    person_surname!: string;
    pin!: string;

    constructor(data?: IProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birth_date = _data["birth_date"];
            this.gender = _data["gender"];
            this.person_name = _data["person_name"];
            this.person_patronymic = _data["person_patronymic"];
            this.person_surname = _data["person_surname"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): Profile {
        data = typeof data === 'object' ? data : {};
        let result = new Profile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birth_date"] = this.birth_date;
        data["gender"] = this.gender;
        data["person_name"] = this.person_name;
        data["person_patronymic"] = this.person_patronymic;
        data["person_surname"] = this.person_surname;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IProfile {
    birth_date: string;
    gender: number;
    person_name: string;
    person_patronymic: string;
    person_surname: string;
    pin: string;
}

export class LaborApiRequest implements ILaborApiRequest {
    pin!: string;

    constructor(data?: ILaborApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): LaborApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LaborApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        return data;
    }
}

export interface ILaborApiRequest {
    pin: string;
}

export class EmployeeCurrentWorkDataModel implements IEmployeeCurrentWorkDataModel {
    error!: string;
    id!: number;
    jsonrpc!: string;
    result!: CurrentResult;

    constructor(data?: IEmployeeCurrentWorkDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.result = new CurrentResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.id = _data["id"];
            this.jsonrpc = _data["jsonrpc"];
            this.result = _data["result"] ? CurrentResult.fromJS(_data["result"]) : new CurrentResult();
        }
    }

    static fromJS(data: any): EmployeeCurrentWorkDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCurrentWorkDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["id"] = this.id;
        data["jsonrpc"] = this.jsonrpc;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeCurrentWorkDataModel {
    error: string;
    id: number;
    jsonrpc: string;
    result: CurrentResult;
}

export class CurrentResult implements ICurrentResult {
    id!: number;
    name!: string;
    partonimic!: string;
    pnfl!: string;
    result_code!: number;
    result_message!: string;
    surname!: string;
    positions!: EmployeePosition[];

    constructor(data?: ICurrentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.positions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.partonimic = _data["partonimic"];
            this.pnfl = _data["pnfl"];
            this.result_code = _data["result_code"];
            this.result_message = _data["result_message"];
            this.surname = _data["surname"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EmployeePosition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurrentResult {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["partonimic"] = this.partonimic;
        data["pnfl"] = this.pnfl;
        data["result_code"] = this.result_code;
        data["result_message"] = this.result_message;
        data["surname"] = this.surname;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICurrentResult {
    id: number;
    name: string;
    partonimic: string;
    pnfl: string;
    result_code: number;
    result_message: string;
    surname: string;
    positions: EmployeePosition[];
}

export class EmployeePosition implements IEmployeePosition {
    begin_date!: string;
    dep_id!: number;
    dep_name!: string;
    doc_begin_num!: string;
    kodp_pn!: string;
    org!: string;
    org_id!: string;
    org_tin!: string;
    position!: string;
    position_id!: number;
    rate!: string;

    constructor(data?: IEmployeePosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.begin_date = _data["begin_date"];
            this.dep_id = _data["dep_id"];
            this.dep_name = _data["dep_name"];
            this.doc_begin_num = _data["doc_begin_num"];
            this.kodp_pn = _data["kodp_pn"];
            this.org = _data["org"];
            this.org_id = _data["org_id"];
            this.org_tin = _data["org_tin"];
            this.position = _data["position"];
            this.position_id = _data["position_id"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): EmployeePosition {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["begin_date"] = this.begin_date;
        data["dep_id"] = this.dep_id;
        data["dep_name"] = this.dep_name;
        data["doc_begin_num"] = this.doc_begin_num;
        data["kodp_pn"] = this.kodp_pn;
        data["org"] = this.org;
        data["org_id"] = this.org_id;
        data["org_tin"] = this.org_tin;
        data["position"] = this.position;
        data["position_id"] = this.position_id;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IEmployeePosition {
    begin_date: string;
    dep_id: number;
    dep_name: string;
    doc_begin_num: string;
    kodp_pn: string;
    org: string;
    org_id: string;
    org_tin: string;
    position: string;
    position_id: number;
    rate: string;
}

export class PedCategoryDto implements IPedCategoryDto {
    subjectID!: number;
    subject?: string | undefined;
    categoryID!: number;
    category?: string | undefined;
    seriyaID!: number;
    sertificate?: string | undefined;
    sertificateSeriesId!: number;
    sertificateNumber?: string | undefined;
    commandNumber?: string | undefined;
    commandDate?: string | undefined;
    isToDateInfinity!: boolean;
    fromDate?: string | undefined;
    toDate?: string | undefined;

    constructor(data?: IPedCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectID = _data["subjectID"];
            this.subject = _data["subject"];
            this.categoryID = _data["categoryID"];
            this.category = _data["category"];
            this.seriyaID = _data["seriyaID"];
            this.sertificate = _data["sertificate"];
            this.sertificateSeriesId = _data["sertificateSeriesId"];
            this.sertificateNumber = _data["sertificateNumber"];
            this.commandNumber = _data["commandNumber"];
            this.commandDate = _data["commandDate"];
            this.isToDateInfinity = _data["isToDateInfinity"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
        }
    }

    static fromJS(data: any): PedCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PedCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectID"] = this.subjectID;
        data["subject"] = this.subject;
        data["categoryID"] = this.categoryID;
        data["category"] = this.category;
        data["seriyaID"] = this.seriyaID;
        data["sertificate"] = this.sertificate;
        data["sertificateSeriesId"] = this.sertificateSeriesId;
        data["sertificateNumber"] = this.sertificateNumber;
        data["commandNumber"] = this.commandNumber;
        data["commandDate"] = this.commandDate;
        data["isToDateInfinity"] = this.isToDateInfinity;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        return data;
    }
}

export interface IPedCategoryDto {
    subjectID: number;
    subject?: string | undefined;
    categoryID: number;
    category?: string | undefined;
    seriyaID: number;
    sertificate?: string | undefined;
    sertificateSeriesId: number;
    sertificateNumber?: string | undefined;
    commandNumber?: string | undefined;
    commandDate?: string | undefined;
    isToDateInfinity: boolean;
    fromDate?: string | undefined;
    toDate?: string | undefined;
}

export class PedCategoryRequestAPI implements IPedCategoryRequestAPI {
    pinfl?: string | undefined;
    passport?: string | undefined;
    passportSeries?: string | undefined;
    passportNumber?: string | undefined;

    constructor(data?: IPedCategoryRequestAPI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pinfl = _data["pinfl"];
            this.passport = _data["passport"];
            this.passportSeries = _data["passportSeries"];
            this.passportNumber = _data["passportNumber"];
        }
    }

    static fromJS(data: any): PedCategoryRequestAPI {
        data = typeof data === 'object' ? data : {};
        let result = new PedCategoryRequestAPI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinfl"] = this.pinfl;
        data["passport"] = this.passport;
        data["passportSeries"] = this.passportSeries;
        data["passportNumber"] = this.passportNumber;
        return data;
    }
}

export interface IPedCategoryRequestAPI {
    pinfl?: string | undefined;
    passport?: string | undefined;
    passportSeries?: string | undefined;
    passportNumber?: string | undefined;
}

export class GcpWithPhotoRequestDto implements IGcpWithPhotoRequestDto {
    transaction_id!: number;
    is_consent?: string | undefined;
    sender_pinfl?: string | undefined;
    langId!: number;
    sender?: string | undefined;
    is_photo?: string | undefined;
    document?: string | undefined;
    pinpp?: string | undefined;
    birth_date?: string | undefined;

    constructor(data?: IGcpWithPhotoRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transaction_id = _data["transaction_id"];
            this.is_consent = _data["is_consent"];
            this.sender_pinfl = _data["sender_pinfl"];
            this.langId = _data["langId"];
            this.sender = _data["sender"];
            this.is_photo = _data["is_photo"];
            this.document = _data["document"];
            this.pinpp = _data["pinpp"];
            this.birth_date = _data["birth_date"];
        }
    }

    static fromJS(data: any): GcpWithPhotoRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GcpWithPhotoRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction_id"] = this.transaction_id;
        data["is_consent"] = this.is_consent;
        data["sender_pinfl"] = this.sender_pinfl;
        data["langId"] = this.langId;
        data["sender"] = this.sender;
        data["is_photo"] = this.is_photo;
        data["document"] = this.document;
        data["pinpp"] = this.pinpp;
        data["birth_date"] = this.birth_date;
        return data;
    }
}

export interface IGcpWithPhotoRequestDto {
    transaction_id: number;
    is_consent?: string | undefined;
    sender_pinfl?: string | undefined;
    langId: number;
    sender?: string | undefined;
    is_photo?: string | undefined;
    document?: string | undefined;
    pinpp?: string | undefined;
    birth_date?: string | undefined;
}

export class GcpWithPhotoResponseDto implements IGcpWithPhotoResponseDto {
    result?: string | undefined;
    data?: GcpData[] | undefined;
    comments?: string | undefined;

    constructor(data?: IGcpWithPhotoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GcpData.fromJS(item));
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): GcpWithPhotoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GcpWithPhotoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        return data;
    }
}

export interface IGcpWithPhotoResponseDto {
    result?: string | undefined;
    data?: GcpData[] | undefined;
    comments?: string | undefined;
}

export class GcpData implements IGcpData {
    transaction_id!: number;
    current_pinpp?: string | undefined;
    pinpps?: string[] | undefined;
    current_document?: string | undefined;
    documents?: GcpDocuments[] | undefined;
    surnamelat?: string | undefined;
    namelat?: string | undefined;
    patronymlat?: string | undefined;
    surnamecyr?: string | undefined;
    namecyr?: string | undefined;
    patronymcyr?: string | undefined;
    engsurname?: string | undefined;
    engname?: string | undefined;
    birth_date?: string | undefined;
    birthplace?: string | undefined;
    birthcountry?: string | undefined;
    birthcountryid!: number;
    livestatus?: string | undefined;
    nationality?: string | undefined;
    nationalityid!: number;
    citizenship?: string | undefined;
    citizenshipid!: number;
    sex!: number;
    photo?: string | undefined;

    constructor(data?: IGcpData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transaction_id = _data["transaction_id"];
            this.current_pinpp = _data["current_pinpp"];
            if (Array.isArray(_data["pinpps"])) {
                this.pinpps = [] as any;
                for (let item of _data["pinpps"])
                    this.pinpps!.push(item);
            }
            this.current_document = _data["current_document"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GcpDocuments.fromJS(item));
            }
            this.surnamelat = _data["surnamelat"];
            this.namelat = _data["namelat"];
            this.patronymlat = _data["patronymlat"];
            this.surnamecyr = _data["surnamecyr"];
            this.namecyr = _data["namecyr"];
            this.patronymcyr = _data["patronymcyr"];
            this.engsurname = _data["engsurname"];
            this.engname = _data["engname"];
            this.birth_date = _data["birth_date"];
            this.birthplace = _data["birthplace"];
            this.birthcountry = _data["birthcountry"];
            this.birthcountryid = _data["birthcountryid"];
            this.livestatus = _data["livestatus"];
            this.nationality = _data["nationality"];
            this.nationalityid = _data["nationalityid"];
            this.citizenship = _data["citizenship"];
            this.citizenshipid = _data["citizenshipid"];
            this.sex = _data["sex"];
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): GcpData {
        data = typeof data === 'object' ? data : {};
        let result = new GcpData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction_id"] = this.transaction_id;
        data["current_pinpp"] = this.current_pinpp;
        if (Array.isArray(this.pinpps)) {
            data["pinpps"] = [];
            for (let item of this.pinpps)
                data["pinpps"].push(item);
        }
        data["current_document"] = this.current_document;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["surnamelat"] = this.surnamelat;
        data["namelat"] = this.namelat;
        data["patronymlat"] = this.patronymlat;
        data["surnamecyr"] = this.surnamecyr;
        data["namecyr"] = this.namecyr;
        data["patronymcyr"] = this.patronymcyr;
        data["engsurname"] = this.engsurname;
        data["engname"] = this.engname;
        data["birth_date"] = this.birth_date;
        data["birthplace"] = this.birthplace;
        data["birthcountry"] = this.birthcountry;
        data["birthcountryid"] = this.birthcountryid;
        data["livestatus"] = this.livestatus;
        data["nationality"] = this.nationality;
        data["nationalityid"] = this.nationalityid;
        data["citizenship"] = this.citizenship;
        data["citizenshipid"] = this.citizenshipid;
        data["sex"] = this.sex;
        data["photo"] = this.photo;
        return data;
    }
}

export interface IGcpData {
    transaction_id: number;
    current_pinpp?: string | undefined;
    pinpps?: string[] | undefined;
    current_document?: string | undefined;
    documents?: GcpDocuments[] | undefined;
    surnamelat?: string | undefined;
    namelat?: string | undefined;
    patronymlat?: string | undefined;
    surnamecyr?: string | undefined;
    namecyr?: string | undefined;
    patronymcyr?: string | undefined;
    engsurname?: string | undefined;
    engname?: string | undefined;
    birth_date?: string | undefined;
    birthplace?: string | undefined;
    birthcountry?: string | undefined;
    birthcountryid: number;
    livestatus?: string | undefined;
    nationality?: string | undefined;
    nationalityid: number;
    citizenship?: string | undefined;
    citizenshipid: number;
    sex: number;
    photo?: string | undefined;
}

export class GcpDocuments implements IGcpDocuments {
    document?: string | undefined;
    type?: string | undefined;
    docgiveplace?: string | undefined;
    docgiveplaceid?: number | undefined;
    datebegin?: string | undefined;
    dateend?: string | undefined;
    status?: string | undefined;

    constructor(data?: IGcpDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"];
            this.type = _data["type"];
            this.docgiveplace = _data["docgiveplace"];
            this.docgiveplaceid = _data["docgiveplaceid"];
            this.datebegin = _data["datebegin"];
            this.dateend = _data["dateend"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GcpDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new GcpDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document;
        data["type"] = this.type;
        data["docgiveplace"] = this.docgiveplace;
        data["docgiveplaceid"] = this.docgiveplaceid;
        data["datebegin"] = this.datebegin;
        data["dateend"] = this.dateend;
        data["status"] = this.status;
        return data;
    }
}

export interface IGcpDocuments {
    document?: string | undefined;
    type?: string | undefined;
    docgiveplace?: string | undefined;
    docgiveplaceid?: number | undefined;
    datebegin?: string | undefined;
    dateend?: string | undefined;
    status?: string | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}